import { iconFactory } from '../iconFactory'

export interface ArrowProps {
  fill?: string
  direction?: 'down' | 'right' | 'left' | 'up'
}

export const Arrow = iconFactory(
  'Arrow',
  ({ fill, direction = 'right' }: ArrowProps) => {
    switch (direction) {
      case 'up':
        return (
          <path
            d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
            fill={fill}
          />
        )
      case 'down':
        return (
          <path
            d="M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z"
            fill={fill}
          />
        )
      case 'left':
        return (
          <path
            d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"
            fill={fill}
          />
        )
      case 'right':
      default:
        return (
          <path
            d="M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z"
            fill={fill}
          />
        )
    }
  },
  { viewBox: '0 0 24 24', width: '24px', height: '24px' },
)
